module.exports = __webpack_public_path__ + "static/winebox-experience-map-2-b76282f642b9b60118295b51bfdf58e4.jpg";